import React from "react"
import { Outlet } from "react-router"
import Header from "./Header"
import Footer from "./Footer"

export default function Layout(prop) {
    const device = prop.device
    return(
        <div className="site-wrapper">
            <Header deviceType = {device} />
            <Outlet />
            <Footer />
        </div>
    )
}
